module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/kharkiv-lviv-ba6d9ea29b487f3e06570dba6e3df0cf.png";